import './quote-slice.scss';
import PropTypes from "prop-types"
import React from "react"


const QuoteSlice = ( { slice } ) => {
    return (
        <blockquote className={`prismic-blockquote callout-border-left callout-accent`}>
            <div dangerouslySetInnerHTML={{ __html: slice.primary.quote_text.html }} />
            {slice.primary.quote_author && (
                <footer>
                    <cite className={`article-blockquote-author`}>{slice.primary.quote_author}</cite>
                </footer>
            )}
        </blockquote>
    );
}

QuoteSlice.propTypes = {
    slice: PropTypes.object.isRequired,
}

export default QuoteSlice
